export default __webpack_public_path__ + "static/media/ox_logo.2006b9e9.png";